import FundList from "components/forms/FundList";
import Card from "../ui/Card";
import { useInvestmentFunds } from "./hooks";
import { GovernmentLevyMessage } from "./styles";

const InvestmentFundsCard = ({ props }: any) => {
  const { availableFunds, showLevyMessage, investmentFundsCardDisabled } =
    useInvestmentFunds();
  const loading = availableFunds === undefined;

  return (
    <Card
      disabled={investmentFundsCardDisabled}
      title="Investment funds"
      {...props}
    >
      <FundList loading={loading} funds={availableFunds || []} />

      {showLevyMessage && (
        <GovernmentLevyMessage>
          <strong>Life Assurance Premium Levy: </strong>A 1% government levy
          applies to all investment products sold in Ireland. Remember to factor
          this in when calculating the net allocation.
        </GovernmentLevyMessage>
      )}
    </Card>
  );
};
export default InvestmentFundsCard;
